export const RECORD_STATUS_TYPES = {
  CONCEPTUAL: 'quick-estimate',
  SCHEMATIC_DESIGN: 'schematic-design',
  PRE_CONSTRUCTION: 'pre-construction',
  CONSTRUCTION_DOCUMENTS: 'construction-documents',
  CONTRACT: 'contract',
  IN_CONSTRUCTION: 'in-construction',
  COMPLETED: 'completed'
};

export const RECORD_STATUS_TYPE_LABELS = {
  [RECORD_STATUS_TYPES.CONCEPTUAL]: 'Conceptual',
  [RECORD_STATUS_TYPES.SCHEMATIC_DESIGN]: 'Schematic Design',
  [RECORD_STATUS_TYPES.PRE_CONSTRUCTION]: 'Design Development',
  [RECORD_STATUS_TYPES.CONSTRUCTION_DOCUMENTS]: 'Construction Documents',
  [RECORD_STATUS_TYPES.CONTRACT]: 'Contract',
  [RECORD_STATUS_TYPES.IN_CONSTRUCTION]: 'In Construction',
  [RECORD_STATUS_TYPES.COMPLETED]: 'Completed'
};

export const PRODUCT_TYPES = {
  // Multifamily
  PODIUM: 'podium',
  WRAP: 'wrap',
  SLAB_ON_GRADE: 'slab_on_grade',
  WOOD_PODIUM: 'wood_podium',
  VARIOUS: 'various',
  HIGH_RISE: 'high_rise',
  // Industrial
  WAREHOUSE: 'warehouse',
  LIGHT_MANUFACTURING: 'light_manufacturing',
  HEAVY_MANUFACTURING: 'heavy_manufacturing',
  COLD_STORAGE: 'cold_storage'
};

export const PRODUCT_TYPE_LABELS = {
  [PRODUCT_TYPES.PODIUM]: 'Podium',
  [PRODUCT_TYPES.WRAP]: 'Wrap',
  [PRODUCT_TYPES.SLAB_ON_GRADE]: 'Slab on Grade',
  [PRODUCT_TYPES.WOOD_PODIUM]: 'Wood Podium',
  [PRODUCT_TYPES.VARIOUS]: 'Various',
  [PRODUCT_TYPES.HIGH_RISE]: 'High Rise',
  [PRODUCT_TYPES.WAREHOUSE]: 'Warehouse',
  [PRODUCT_TYPES.LIGHT_MANUFACTURING]: 'Light Manufacturing',
  [PRODUCT_TYPES.HEAVY_MANUFACTURING]: 'Heavy Manufacturing',
  [PRODUCT_TYPES.COLD_STORAGE]: 'Cold Storage'
};

export const CONSTRUCTION_TYPES = {
  TYPE_I: 'Type I',
  TYPE_II: 'Type II',
  TYPE_III: 'Type III',
  TYPE_V: 'Type V',
  VARIOUS: 'Various'
};

export const CONSTRUCTION_TYPE_LABELS = {
  [CONSTRUCTION_TYPES.TYPE_I]: 'Type I',
  [CONSTRUCTION_TYPES.TYPE_II]: 'Type II',
  [CONSTRUCTION_TYPES.TYPE_III]: 'Type III',
  [CONSTRUCTION_TYPES.TYPE_V]: 'Type V',
  [CONSTRUCTION_TYPES.VARIOUS]: 'Various'
};

export const RENTAL_TYPES = {
  MARKET_RATE: 'market_rate',
  AFFORDABLE: 'affordable',
  MIXED_INCOME: 'mixed_income'
};

export const RENTAL_TYPE_LABELS = {
  [RENTAL_TYPES.MARKET_RATE]: 'Market Rate',
  [RENTAL_TYPES.AFFORDABLE]: 'Affordable',
  [RENTAL_TYPES.MIXED_INCOME]: 'Mixed Income'
};

export const MULTIFAMILY_RENTAL_TYPES = [RENTAL_TYPES.MARKET_RATE, RENTAL_TYPES.AFFORDABLE, RENTAL_TYPES.MIXED_INCOME];

export const SCOPE_TYPES = {
  NEW_CONSTRUCTION: 'New Construction',
  RENOVATION: 'Renovation'
};

export const RECORD_TYPES = {
  HISTORICAL: 'historical',
  ESTIMATE: 'estimate'
};

export const RECORD_TYPE_LABELS = {
  [RECORD_TYPES.HISTORICAL]: 'Historical',
  [RECORD_TYPES.ESTIMATE]: 'Estimate'
};
